module.exports = __webpack_public_path__ + "img/icon-user.ccf7bd6d.svg";